import React from 'react';
import {Button, PaddingModes} from '@wix/wix-ui-tpa/cssVars';
import {LikeHeart, LikeHeartFill} from '@wix/wix-ui-icons-common/on-stage';
import classNames from 'classnames';
import {withGlobals} from '../../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../../../gallery/galleryGlobalStrategy';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import s from './WishlistButton.scss';
import {classes as wishlistButtonStylable} from './WishlistButton.st.css';
import {useWishlist} from './hooks/useWishlist';

export const WishlistButtonDataHook = {
  Container: 'gallery-wishlist-button-container',
  Root: 'gallery-wishlist-button',
  IconContainer: 'gallery-wishlist-button-icon-container',
  Icon: 'gallery-wishlist-button-icon',
};

export interface WishlistButtonProps extends IGalleryGlobalProps, IProvidedTranslationProps {
  productId: string;
}

const WishlistButtonComponent: React.FC<WishlistButtonProps> = ({globals, productId, t}) => {
  const {shouldShowMobile} = globals;
  const {inWishlist, toggleWishlist} = useWishlist(productId);

  const stopLinkNavigation = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleWishlistButtonClick = (event: React.MouseEvent) => {
    stopLinkNavigation(event);
    toggleWishlist();
  };

  const ariaLabel = inWishlist ? t('removeFromWishlistAriaLabel') : t('addToWishlistAriaLabel');

  return (
    <Button
      type="button"
      className={classNames(s.wishlistButton, wishlistButtonStylable.wishlistButton)}
      {...(shouldShowMobile && {paddingMode: PaddingModes.explicitPaddings})}
      data-hook={WishlistButtonDataHook.Root}
      aria-label={ariaLabel}
      aria-pressed={inWishlist}
      onMouseDown={stopLinkNavigation}
      onClickCapture={handleWishlistButtonClick}>
      <i className={s.iconContainer} data-hook={WishlistButtonDataHook.IconContainer}>
        {inWishlist ? (
          <LikeHeartFill className={classNames(s.heartIcon, s.filled)} data-hook={WishlistButtonDataHook.Icon} />
        ) : (
          <LikeHeart className={classNames(s.heartIcon)} data-hook={WishlistButtonDataHook.Icon} />
        )}
      </i>
    </Button>
  );
};

export const WishlistButton = withGlobals(withTranslations()(WishlistButtonComponent));
